import React from 'react';
import { Volleyball, Crown, Plane, ChefHat } from 'lucide-react';
import '../styles/hobbies.css';

const Hobbies = () => {
  const otherHobbies = [
    {
      name: 'Chess',
      icon: Crown,
      description: 'Strategic thinking and problem solving'
    },
    {
      name: 'Traveling',
      icon: Plane,
      description: 'Exploring new places and cultures'
    },
    {
      name: 'Cooking',
      icon: ChefHat,
      description: 'Experimenting with new recipes'
    }
  ];

  const volleyballImages = [
    '/volleyball-1.jpg',
    '/volleyball-2.jpg',
    '/volleyball-3.png'
  ];

  const achievements = [
    '10 years of competitive volleyball experience and 4 years in beach volleyball',
    'Proud member of Team Romania, representing my country in both indoor and beach volleyball',
    'Captain of my U20 club team',
    'Competed at the FISU World University Games in Beach Volleyball',
    'Balkan Silver Medalist with back-to-back National Gold Medals in Beach Volleyball',
    'Silver and Bronze National Medalist in Indoor Volleyball'
  ];

  return (
    <section id="hobbies" className="hobbies-section">
      <div className="hobbies-container">
        <div className="section-header">
          <h2 className="section-title">Hobbies & Interests</h2>
          <div className="section-divider"></div>
          <p className="section-description">
            Beyond coding, I enjoy staying active and exploring new experiences
          </p>
        </div>

        {/* Featured Volleyball Section */}
        <div className="volleyball-featured">
          <div className="volleyball-content">
            <div className="volleyball-header">
              <div className="volleyball-icon-large">
                <Volleyball size={48} />
              </div>
              <h3 className="volleyball-title">Volleyball</h3>
            </div>
            
            <div className="volleyball-images">
              {volleyballImages.map((image, index) => (
                <div key={index} className="volleyball-image">
                  <img src={image} alt={`Volleyball ${index + 1}`} />
                </div>
              ))}
            </div>

            <div className="volleyball-achievements">
              <h4 className="achievements-title">Achievements & Experience</h4>
              <ul className="achievements-list">
                {achievements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Other Hobbies */}
        <div className="other-hobbies">
          <h3 className="other-hobbies-title">Other Interests</h3>
          <div className="hobbies-grid">
            {otherHobbies.map((hobby, index) => {
              const Icon = hobby.icon;
              return (
                <div key={index} className="hobby-card">
                  <div className="hobby-icon">
                    <Icon size={32} />
                  </div>
                  <h3 className="hobby-name">{hobby.name}</h3>
                  <p className="hobby-description">{hobby.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hobbies;